import {HTTPMethod} from '../../enum/http-method';

export class RequestBase {

  static get HOST_URL(): string {
    // API接続先は、環境変数 APP_URL で切り替える
    let url : string = process.env.API_URL || "";

    return url;
  }

  private host: string = '';
  method: HTTPMethod;
  endPoint: string = '';
  param: any = {};

  protected constructor(method: HTTPMethod, endpoint: string) {
    this.host = RequestBase.HOST_URL || "http://localhost";
    this.method = method;
    this.endPoint = endpoint;
  }

  getHost(): string {
    return this.host;
  }

  getEndPoint(): string {
    return this.endPoint;
  }

  getMethod(): HTTPMethod {
    return this.method;
  }

  getUrl(): string {
    switch (this.method) {
      case HTTPMethod.GET:
        return this.getUrlWithQueryParam();
      case HTTPMethod.POST:
        return this.getUrlNoQueryParam();
      case HTTPMethod.DELETE:
        return this.getUrlWithQueryParam();
      case HTTPMethod.PATCH:
        return this.getUrlNoQueryParam();
      default:
        console.error(`getUrl() is no support this method !!`);
        return '';
    }
  };

  /**
   * URL作成メソッド
   * クエリーパラメータ付き
   */
  private getUrlWithQueryParam(): string {
    return `${this.getHost()}${this.getEndPoint()}${this.getParam()}`;
  }

  /**
   * URL作成メソッド
   * クエリーパラメータ無し
   */
  private getUrlNoQueryParam(): string {
    return `${this.getHost()}${this.getEndPoint()}`;
  }

  getParam(): FormData | string {
    switch (this.method) {
      case HTTPMethod.GET:
        return this.getParamQueryParam();
      case HTTPMethod.POST:
        return this.getParamFormData();
      case HTTPMethod.DELETE:
        return this.getParamQueryParam();
      case HTTPMethod.PATCH:
        return this.getParamFormData();
      default:
        console.error(`getParam() is no support this method !!`);
        return '';
    }
  };

  /**
   * パラメータ作成メソッド
   * クエリーパラメータ
   */
  private getParamQueryParam(): string {
    let query: string = '?';
    Object.keys(this.param).forEach((key: string, i: number) => {
      query += `${i ? '&' : ''}${key}=${this.param[key]}`;
    });
    return query;
  }

  /**
   * パラメータ作成メソッド
   * フォームデータ
   */
  private getParamFormData(): FormData {
    const formData: FormData = new FormData();
    Object.keys(this.param).forEach((key: string) => {
      formData.append(key, this.param[key]);
    });
    return formData;
  }
}
